import { createAction, props } from '@ngrx/store';
import { Account } from '../models/account';
import { AccountFilter } from '../models/account.filter';
import { Wallet } from '../models/wallet';
//import { Card } from 'src/app/modules/card/models/card';
//import { CardRegister } from 'src/app/modules/card/models/card.register';
import { KycDocument } from '../models/document';
import { BankAccount } from '../models/bank-account';

export const AddAccounts = createAction('ADD ACCOUNTS', props<{ accounts: Account[] }>());

export const AddAccount = createAction('ADD ACCOUNT', props<{ account: Account }>());
export const AddBankAccounts = createAction('ADD BANK ACCOUNTS', props<{ accounts: BankAccount[] }>());

export const AddCurrentAccount = createAction('ADD CURRENT ACCOUNT', props<{ accounts: Account[] }>());

export const AddOrUpdateCurrentAccount = createAction('ADD OR UPDATE CURRENT ACCOUNT', props<{ account: Account }>());

export const UpdateAccount = createAction('UPDATE ACCOUNT', props<{ id: string; change: Partial<Account> }>());

export const AddAccountFilter = createAction('ADD ACCOUNT FILTER', props<{ filter: AccountFilter }>());

export const RemoveAccountFilter = createAction('REMOVE ACCOUNT FILTER');

export const AddError = createAction('ADD ACCOUNT ERROR', props<{ error: any }>());

export const AddTotalCount = createAction('ADD ACCOUNT TOTAL COUNT', props<{ totalCount: number }>());

export const UpdateWallet = createAction('UPDATE ACCOUNT WALLET', props<{ accountId: string; wallet: Wallet }>());

export const AddWallet = createAction('ADD ACCOUNT WALLET', props<{ accountId: string; wallet: Wallet }>());

//export const AddCard = createAction('ADD ACCOUNT CARD', props<{ accountId: string, card: Card }>());

export const AddSuccess = createAction('[ACCOUNT API] ADD SUCCESS');

export const AddKycDocument = createAction('ADD KYC DOCUMENT', props<{ kycDocuments: KycDocument[] }>());

// Effect actions

export const FetchAccounts = createAction(
  '[Api] FETCH ACCOUNTS',
  props<{
    search: string;
    pageIndex: number;
    pageSize: number;
    filter: AccountFilter;
  }>()
);

export const CreateAccount = createAction('[Api] REGISTER ACCOUNT', props<{ account: Account }>());

export const ModifyAccount = createAction('[Api] UPDATE ACCOUNT', props<{ id: string; update: Partial<Account> }>());

export const FetchAccountsByUserId = createAction('[Api] FETCH ACCOUNTS BY USER ID', props<{ userId: string }>());

export const FetchCurrentAccounts = createAction('[Api] FETCH CURRENT LOGGED IN ACCOUNTS');
export const FetchKycDocument = createAction('[Api] FETCH KYC DOCUMENT', props<{ accountId: string }>());

export const GetAccount = createAction('[Api] GET ACCOUNT', props<{ id: string }>());

export const GetAccountWallet = createAction(
  '[Api] FETCH ACCOUNT WALLET',
  props<{ id: string; provider: string; providerId: string }>()
);

export const SaveAccountWallet = createAction('[Api] SAVE ACCOUNT WALLET', props<{ id: string; wallet: Wallet }>());

//export const SaveAccountCard = createAction('[Api] SAVE ACCOUNT CARD', props<{ id: string, cardRegister: CardRegister }>());
export const SaveKycDocument = createAction(
  '[Api] SAVE KYC DOCUMENT',
  props<{ accountId: string; kycDocument: KycDocument }>()
);
export const SubmitKycDocument = createAction(
  '[Api] SUBMIT KYC DOCUMENT',
  props<{ accountId: string; documentRef: string }>()
);
export const SaveBankIbanNumber = createAction(
  '[Api] SAVE BANK IBAN NUMBER',
  props<{ accountId: string; token: string }>()
);
